import React, { Component } from "react";
import {FormBlocks} from './FormBlocks';
import {formFieldsAttributes} from '../../FormBuilderFunctions/FieldProps';
import {currencyListUtil} from '../../../../Utils/CommonFunctions';
import {callPOST} from '../../../../Utils/ApiUtil';
import Wrp from '../../../../hoc/Wrp/Wrp';
import ExchangeRateConversion from './ExchangeRateConversion';


class Currency  extends Component {
  state ={
    historyCurrency:0,
    currentCurrenctValue:this.props.value,
    currencyValue:'',
    bottomPopup:false,
    historyPopup:false,
    isOpenCurrencyConversion:false,
    exchangeRates:{
      exchange_rate: '',
      from_currency_code: "",
      to_currency_code: "",
      value: ''
    }
  }
  toogleConvertCurrency = ()=>{
    const{isOpenCurrencyConversion} = this.state;
    this.setState({
        historyPopup: false,
        isOpenCurrencyConversion:!isOpenCurrencyConversion
    })
  }
  applyAndClose = (currencyValue)=>{
    this.setState({
        isOpenCurrencyConversion:false,
        currencyValue:currencyValue
    })
  }
  
    toFixedHandler = (value) =>{
      const decimal = (this.props.item && this.props.item.decimal && this.props.item.decimal!==null)? this.props.item.decimal :(this.props.item && this.props.item.decimal_places && this.props.item.decimal_places!==null)?this.props.item.decimal_places:2;
      value = (value)?value:0;
      return parseFloat(value).toFixed(decimal);
    }
    // componentDidUpdate(){
    //     console.log(this.props);
    // }
    showHistoryPopup = ()=>{
      this.setState(prevState => ({
        historyPopup: !prevState.historyPopup
      }));
    }
    
    currencyOnBlur = (value)=>{
      const rgx =/(\d+)(?:\s*)([\+\-\*\/])(?:\s*)(\d+)/;
      if(rgx.test(value)!== false){
        this.setState({currencyValue:this.toFixedHandler(this.state.currentCurrenctValue),bottomPopup:false});
        this.props.onChangeInputAction(this.props.fieldObj,this.toFixedHandler(this.state.currentCurrenctValue),'number')
      }else{
        // console.log(this.props.item.decimal);
        this.setState({currencyValue:this.toFixedHandler(value),currentCurrenctValue:value,bottomPopup:false});
        this.props.onChangeInputAction(this.props.fieldObj,this.toFixedHandler(value),'number')
      }
      this.props.onBlurHandlerAction(this.props.fieldObj,this.toFixedHandler(value),'number')
    }
    setHistoryValue= () =>{
      this.setState({currencyValue:this.state.historyCurrency,historyPopup:false});
    }
    currencyOnChange =(value)=>{
      const rgx =/(\d+)(?:\s*)([\+\-\*\/])(?:\s*)(\d+)/;
      let curValue = null;
      try{
        this.setState({currencyValue:value,bottomPopup:true});
        if(rgx.test(value)!== false){
          curValue = eval(value);
          this.setState({historyCurrency:(value)});
          this.setState({currentCurrenctValue:(curValue)})
          this.props.onChangeInputAction(this.props.fieldObj,curValue,'number')
        }else{
          this.setState({currentCurrenctValue:(value),bottomPopup:true});
          this.props.onChangeInputAction(this.props.fieldObj,curValue,'number')
        }
      }catch(e){
        console.log(e);
      }
       
        
    }  
    componentDidMount = ()=>{
     
      const updateData = {
        ...this.props.fieldObj,
        ...this.props.subformObj
      }
      const attr = formFieldsAttributes(
        {...this.props.item,className:this.props.className,hideMandatory:true,
      },this.props.validationForms,e =>this.currencyOnChange(updateData,e))
      this.setState({currencyValue:attr.value});
     } 

  //CURRENCY LIST CHANGE HANDLER   
  currenctyListChangeHandler = (e)=>{
    // console.log(e.target.value);
    const value = e.target.value;
    const {item} = this.props;
    // const currencyList =  currencyListUtil();
    const currentCurrency = (item.currency_code===undefined)?'CAD':item.currency_code;
    this.updateCurrencyValueByFormat({
      fromCode:currentCurrency,
      toCode:value,
      selectedValue:item.selectedValue,
    });
    this.props.onChangeInputAction(this.props.fieldObj,value,'currencyType');
  } 
  updateCurrencyValueByFormat = (param,has_currency_conversion=false)=>{
    // console.log(param, 'paramparam',this.state.currencyValue, this.props)
    let API_Url = "currency/convert";
    const payload={
	    from_currency_code:param.fromCode,
	    to_currency_code:param.toCode,
	    value: param.selectedValue
	  }
    callPOST(API_Url,payload)
      .then(res => {
        if(res.status===200){ 
          const response = res.data;
          if(response.code===200){
              const responseData = response.data;
              let convertedValue = this.toFixedHandler(responseData.value);
                //console.log('responseData.value==',responseData.value);
                if(has_currency_conversion===false){
                  this.props.onChangeInputAction(this.props.fieldObj,convertedValue,'number');
                  this.setState({
                    exchangeRates:responseData,
                    currencyValue:convertedValue,
                    bottomPopup:false});
                }else{
                  this.setState({
                    exchangeRates:responseData,
                  });
                }
          }
        }     
      })
    .catch(err => {
      console.log(err);
    })
  }   
  render() {
    const  {
      type,
      item,
      className,
      validationForms,
      section,
      fieldObj,
    } = this.props;
    // console.log('this.props.',this.props,fieldObj);
    const updateData = {
     ...fieldObj
    }
    const attr = formFieldsAttributes(
      {...item,className:className,hideMandatory:true,
    },validationForms)
    const currencyList =  currencyListUtil();
    // item.has_currency_conversion = true;
    let readonlyVal = false;
    if(attr.fieldAttributes && attr.fieldAttributes.readOnly) {
       readonlyVal = attr.fieldAttributes.readOnly;
    }
  return (
      <FormBlocks {...this.props}  attr={attr}>
        <div className="input-group border-0">
          <div className="input-group-prepend">
          <select className="form-control" 
            disabled={(item.has_currency_conversion===true)?true:false}
            onChange={e=>this.currenctyListChangeHandler(e)} value={(item.currency_code===undefined)?'CAD':item.currency_code}
            {...attr.fieldAttributes}>
            {currencyList.map((currency,currIndex)=>{
              return(
                <option key={currIndex}  value={currency.key}>{currency.value}</option>
              )
            })}
            </select>
          </div> 
          <input 
            type={type}
            value={this.state.currencyValue}
            onChange={e =>this.currencyOnChange(e.target.value)}
            onBlur={e =>this.currencyOnBlur(e.target.value)}
            {...attr.fieldAttributes}
          />
          {(item.has_currency_conversion===true)?
           <Wrp>
            <ExchangeRateConversion
            {...this.props} 
            currency_code={(item.currency_code===undefined)?'CAD':item.currency_code}
            currencyValue={this.state.currencyValue}
            toogleConvertCurrency={this.toogleConvertCurrency}
            isOpenCurrencyConversion={this.state.isOpenCurrencyConversion}
            updateCurrencyValueByFormat={this.updateCurrencyValueByFormat}
            exchangeRates={this.state.exchangeRates}
            applyAndClose={this.applyAndClose}
            toFixedHandler={this.toFixedHandler}
            currencyList={currencyList} />
            {/*
            {(this.state.isOpenCurrencyConversion===true)?
              <div className="bg-overlay overlayVisible" style={{zIndex:'999'}}></div>
            :''}
            */}
            </Wrp>
          :''}
          
          
          
          {(this.state.bottomPopup && this.state.currencyValue!==0)?
          <div onClick={this.currencyOnBlur.bind(this.state.currencyValue)} className={"card currencyPop"}>
            <div className="card-body p-1">={this.state.currentCurrenctValue}</div>
          </div>
        :''}
        { readonlyVal !== true ?
          <div className={(item.required===true)? 'mandatory input-group-append':'input-group-append'}  data-original-title="" adata-toggle="popover" data-content={this.state.historyCurrency+"="+eval(this.state.historyCurrency)} data-placement="bottom"> <a className="input-group-text" onClick={this.showHistoryPopup}><i className="fas fa-info"></i></a>
          </div>
        : null }
          
         {(this.state.historyPopup)?
          <div className="card currencyPop">
            <div className="card-body p-1" onClick={this.setHistoryValue} >{this.state.historyCurrency+"="+eval(this.state.historyCurrency)}</div>
          </div>
        :''}
      </div>
      
      
      </FormBlocks>
    );
  }
}

Currency.defaultProps = {
  className: "form-control",
}

export default Currency;
